import { Navigate, Route, Routes } from 'hotel/navigation';

import TravelerOrAdminRoute from '../components/TravelerOrAdminRoute';
import Requests from '../pages/Requests';
import RequestDetailsPage from '../pages/Requests/RequestDetailsPage';
import NewReservation from '../pages/Roster/NewReservation';
import RequestChanges from '../pages/Roster/RequestChanges';

const RosterRoutes = () => {
  return (
    <Routes>
      <Route index element={<Requests />} />
      <Route
        path="change"
        element={
          <TravelerOrAdminRoute>
            <RequestChanges />
          </TravelerOrAdminRoute>
        }
      />
      <Route
        path="new"
        element={
          <TravelerOrAdminRoute>
            <NewReservation />
          </TravelerOrAdminRoute>
        }
      />
      <Route path="*" element={<Navigate to="/requests" />} />
      <Route path=":id" element={<RequestDetailsPage />} />
    </Routes>
  );
};

export default RosterRoutes;
